import { Controller } from "@hotwired/stimulus";
import { createConsumer } from "@rails/actioncable/src";

// Subscribes to UserChannel via ActionCable and updates navbar badges
// (messaging, flash infos, notifications) in real-time.
//
// Reuses the global consumer set in application.js when available,
// falling back to creating a new one.
//
// Usage: add data-controller="user-channel" to the <body>.
export default class extends Controller {
  connect() {
    const consumer = window._cableConsumer || createConsumer();
    this.subscription = consumer.subscriptions.create("UserChannel", {
      received: (data) => this.handleMessage(data),
    });
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  handleMessage(data) {
    switch (data.action) {
      case "new_message":
        this.incrementBadge("messaging-badge");
        this.incrementUnreadCell(data.conversation_id);
        break;
      case "new_story":
        this.showFlashInfoBadge();
        break;
      case "new_notification":
        this.incrementBadge("notification-badge");
        break;
      case "presence_update":
        document.dispatchEvent(new CustomEvent("presence:update", {
          detail: {
            userId: data.user_id,
            online: data.online,
            lastSeenAt: data.last_seen_at,
          },
        }));
        break;
    }
  }

  // Increment a numeric badge (messaging or notifications).
  incrementBadge(id) {
    const badge = document.getElementById(id);
    if (!badge) return;

    const current = parseInt(badge.dataset.count || "0", 10);
    const next = current + 1;
    badge.dataset.count = next;
    badge.textContent = next > 9 ? "9+" : next;
    badge.classList.remove("hidden");
  }

  // Increment the unread badge in the conversations table for a specific conversation.
  incrementUnreadCell(conversationId) {
    if (!conversationId) return;

    const cell = document.getElementById(`unread-cell-${conversationId}`);
    if (!cell) return;

    const current = parseInt(cell.dataset.unreadCount || "0", 10);
    const next = current + 1;
    cell.dataset.unreadCount = next;

    const badge = cell.querySelector(".unread-badge");
    if (badge) {
      badge.className = "unread-badge inline-flex items-center justify-center min-w-[22px] h-[22px] px-1.5 rounded-full text-xs font-bold bg-red-500 text-white";
      badge.innerHTML = next > 99 ? "99+" : next;
    }
  }

  // Show the green pulsing dot for flash infos.
  showFlashInfoBadge() {
    const badge = document.getElementById("flash-info-badge");
    if (!badge) return;
    badge.classList.remove("hidden");
  }
}
